<template>
  <div>
    <h1 class="mb-4">
      {{ $t("fund.report.stepModelRequirements.title") }}
    </h1>

    <v-card>
      <StepModelRequirementsCategories
        :fund="fund"
        :categories="categories"
        :audit="audit"
        :audituser="audituser"
        :audited="audited"
        :type="type"
      />
    </v-card>
  </div>
</template>

<script>
import StepModelRequirementsCategories from "./StepModelRequirementsCategories";

export default {
  components: {
    StepModelRequirementsCategories,
  },

  props: {
    fund: {
      type: Object,
      required: true,
    },

    categories: {
      type: Array,
      required: true,
    },

    audit: {
      type: Boolean,
      default: false,
    },

    audited: {
      type: Boolean,
      default: true,
    },

    audituser: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: "final",
    },
  },
};
</script>
